<lazy-echart
    class="chart"
    [options]="chartOptions"
    [class.chart--fixed-height-tall]="hasFixedHeight"
    (chartClick)="chartClicked($event)"
></lazy-echart>
